import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "swiper-navigation-btn select-none"
}
const _hoisted_2 = ["src"]
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 您的瀏覽器不支援影片播放。 ")
const _hoisted_4 = ["onClick", "src"]
const _hoisted_5 = ["onClick", "src"]
const _hoisted_6 = ["poster"]
const _hoisted_7 = ["src"]
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 您的瀏覽器不支援影片播放。 ")
const _hoisted_9 = ["src"]
const _hoisted_10 = ["src", "onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SwiperNavBtn = _resolveComponent("SwiperNavBtn")!
  const _component_SwiperSlide = _resolveComponent("SwiperSlide")!
  const _component_Swiper = _resolveComponent("Swiper")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["g-swiper-square-item", _ctx.customClass])
  }, [
    (_ctx.selectItemRef.length > 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_SwiperNavBtn, {
            onNextClick: _ctx.nextClick,
            onPrevClick: _ctx.prevClick
          }, null, 8, ["onNextClick", "onPrevClick"])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_Swiper, {
      class: "swiper",
      modules: _ctx.modules,
      scrollbar: { hide: false, draggable: true },
      onSwiper: _ctx.setControlledSwiper,
      autoplay: false,
      navigation: {
        hiddenClass: 'swiper-button-hidden',
        prevEl: 'g-swiper-nav-prev',
        nextEl: 'g-swiper-nav-next',
      },
      onSlideChange: _ctx.handleSlideChange,
      onSlideChangeTransitionEnd: _ctx.handleSlideChangeEnd
    }, {
      default: _withCtx(() => [
        _renderSlot(_ctx.$slots, "editImage"),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectItemRef, (image, index) => {
          return (_openBlock(), _createBlock(_component_SwiperSlide, {
            key: index,
            class: "slide hidden sm:block content-center"
          }, {
            default: _withCtx(() => [
              (typeof image.Image === 'object' && _ctx.isVideo(image.Image.PcWeb) && !_ctx.isMobile().phone)
                ? (_openBlock(), _createElementBlock("video", {
                    key: 0,
                    class: "video-player",
                    style: _normalizeStyle({ width: _ctx.height }),
                    controlsList: "nodownload noplaybackrate",
                    disablePictureInPicture: "",
                    preload: "auto",
                    playsinline: "",
                    muted: false,
                    controls: "",
                    onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.togglePlay && _ctx.togglePlay(...args)), ["stop","prevent"]))
                  }, [
                    _createElementVNode("source", {
                      src: image.Image.PcWeb,
                      type: "video/mp4"
                    }, null, 8, _hoisted_2),
                    _hoisted_3
                  ], 4))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    (_ctx.imageTypeRef === 'normal' && typeof image.Image === 'object')
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          onClick: ($event: any) => (image.Link ? _ctx.goToLink(image.Link) : null),
                          id: "IMG_2",
                          style: _normalizeStyle({ width: _ctx.height }),
                          src: image.Image.PcWeb
                        }, null, 12, _hoisted_4))
                      : (_ctx.imageTypeRef === 'ads' && typeof image.Image === 'string')
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 1,
                            onClick: ($event: any) => (image.Link ? _ctx.goToLink(image.Link) : null),
                            id: "IMG_2",
                            style: _normalizeStyle({ width: _ctx.height }),
                            src: image.Image,
                            class: "cursor-pointer"
                          }, null, 12, _hoisted_5))
                        : _createCommentVNode("", true)
                  ], 64))
            ]),
            _: 2
          }, 1024))
        }), 128)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectItemRef, (image, index) => {
          return (_openBlock(), _createBlock(_component_SwiperSlide, {
            key: index,
            class: "slide sm:hidden content-center"
          }, {
            default: _withCtx(() => [
              (typeof image.Image === 'object' && _ctx.isVideo(image.Image.MobileWeb) && _ctx.isMobile().phone)
                ? (_openBlock(), _createElementBlock("video", {
                    key: 0,
                    class: "video-player",
                    style: { width: `100%` },
                    controlsList: "nodownload noplaybackrate",
                    disablePictureInPicture: "",
                    preload: "auto",
                    playsinline: "",
                    muted: false,
                    controls: "",
                    "webkit-playsinline": "",
                    "x5-playsinline": "",
                    "x5-video-player-type": "h5",
                    "x5-video-player-fullscreen": "true",
                    "x5-video-orientation": "portraint",
                    poster: typeof image.Image === 'object' ? image.Image.MobileWeb.replace(/\.(mp4|mov|MP4|MOV)$/, '.jpg') : '',
                    onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.togglePlay && _ctx.togglePlay(...args)), ["stop","prevent"]))
                  }, [
                    _createElementVNode("source", {
                      src: image.Image.MobileWeb,
                      type: "video/mp4"
                    }, null, 8, _hoisted_7),
                    _hoisted_8
                  ], 8, _hoisted_6))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    (_ctx.imageTypeRef === 'normal' && typeof image.Image === 'object')
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          id: "IMG_2",
                          style: { width: `100%` },
                          src: image.Image.MobileWeb
                        }, null, 8, _hoisted_9))
                      : (_ctx.imageTypeRef === 'ads' && typeof image.Image === 'string')
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 1,
                            id: "IMG_2",
                            style: { width: `100%` },
                            src: image.Image,
                            class: "cursor-pointer",
                            onClick: ($event: any) => (image.Link ? _ctx.goToLink(image.Link) : null)
                          }, null, 8, _hoisted_10))
                        : _createCommentVNode("", true)
                  ], 64))
            ]),
            _: 2
          }, 1024))
        }), 128))
      ]),
      _: 3
    }, 8, ["modules", "onSwiper", "onSlideChange", "onSlideChangeTransitionEnd"])
  ], 2))
}